import { getNotices } from '../../service/home';
import { getLotteryTypes, getLotteryLatest, getLongQueue, getStatistics } from '../../service/lottery';
import { getLocalLotteryType } from '../../utils/localStorageService';


export const state = {
  routerPage: 'pk10',
  notices: [],
  headTabs: [],
  lottery_list: [],
  longQueue: [],
  statistics: [],
  // 胆拖、等玩法的radio
  playTypeRadio: '1',
  // 如果是胆拖状态，计算点击值
  playDantuoTotal: {},
  lhItemTotal: {}, // 六合点击时，记录点击数，在点击时需要校验
  lhTabData: {}, // 点击时，保存六合的子玩法的所有数据参数
};

export const actions = {
  // 头部数据
  async fetchHeadTabs({dispatch}) {
    const info = await getLotteryTypes();
    if (info.result === 'ok') dispatch('setHeadTabs', info.data);
  },
  // 头部数据
  setHeadTabs({commit}, tabs) {
    if (!tabs.length) return;
    commit('SET_HEAD_TABS', tabs);
  },
  async getNotices({commit}) {
    const info = await getNotices();
    if (info.result === 'ok') {
      commit('SET_NOTICES', info.data);
    }
  },

  // 获取投注记录
  async getLotteryLatest({commit}) {
    const info = await getLotteryLatest();
    if (info.result === 'ok') {
      commit('SET_LOTTERY_LATEST_DATA', info.data);
    }
  },

  // 获取长龙
  async getLongQueue({commit, state}, {lottery_type}) {
    const info = await getLongQueue(lottery_type);
    if (info.result === 'ok') {
      commit('SET_LONGQUEUE_DATA', info.data);
    }
  },

  // 获取开奖统计
  async getStatistics({commit, state}, {lottery_type}) {
    const info = await getStatistics(lottery_type);
    if (info.result === 'ok') {
      commit('SET_STATISTICS_DATA', info.data);
    }
  },
  // 修改玩法类型
  onSetPlayTypeRadio({commit, state}, type) {
    commit('SET_PLAY_TYPE_RADIO', type);
  },
  // 计算胆拖点击次数
  onSetPlayDantuoTotal({commit, state}, type) {
    commit('SET_PLAY_DANTUO_TOTAL', type);
  },
  // 计算胆拖点击次数
  onSetLhItemTotal({commit, state}, type) {
    commit('SET_LH_ITEM_TOTAL', type);
  },
  // 保存六合当前玩法的数据
  onSetLhTabData({commit, state}, type) {
    commit('SET_LH_TAB_DATA', type);
  }
};

export const mutations = {
  ['SET_HEAD_TABS'](state, tabs) {
    const newLotteryType = getLocalLotteryType();
    state.headTabs = newLotteryType || tabs;
  },
  ['SET_NOTICES'](state, notices) {
    state.notices = notices;
  },
  ['SET_LOTTERY_LATEST_DATA'](state, lottery_list) {
    state.lottery_list = lottery_list;
  },
  ['SET_LONGQUEUE_DATA'](state, longQueue) {
    state.longQueue = longQueue;
  },
  ['SET_STATISTICS_DATA'](state, statistics) {
    state.statistics = statistics;
  },
  ['SET_PLAY_TYPE_RADIO'](state, playTypeRadio) {
    state.playTypeRadio = playTypeRadio;
  },
  ['SET_PLAY_DANTUO_TOTAL'](state, playDantuoTotal) {
    state.playDantuoTotal = playDantuoTotal;
  },
  ['SET_LH_ITEM_TOTAL'](state, payload) {
    state.lhItemTotal = payload;
  },
  ['SET_LH_TAB_DATA'](state, payload) {
    state.lhTabData = payload;
  }
};

export const getters = {
  headTabs: state => state.headTabs
};



// WEBPACK FOOTER //
// ./src/pages/home/store.js